import selectInsurance from 'utils/selectInsurance';

const getInsuranceRelationToInsured = ({ patient, insurance, value, blankSelf = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const relationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured'] : null;
  return (blankSelf && relationToInsured && relationToInsured === 'Self')
    ? '' : relationToInsured;
};

export default getInsuranceRelationToInsured;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceRelationToInsured.js